
import { DOWNLOAD_HOTSPOT_ERROR, DOWNLOAD_HOTSPOT_POST_ERROR, DOWNLOAD_HOTSPOT_SUCCESS } from "../actions/types";

export default (state = {  
    error: null,
    status:[],  
}, action) => {
    switch (action.type) {
        case DOWNLOAD_HOTSPOT_ERROR:
            return {
                ...state,
                error: state.error,
                loading:false,
                success: action.payload,
            };
            break;
        case DOWNLOAD_HOTSPOT_SUCCESS:
            return {
                ...state,
                error: state.error,
                loading:false,
                status: action.payload,
                success:true
            };
            break;
        case DOWNLOAD_HOTSPOT_POST_ERROR:
            return {
                ...state,
                error: state.error,
                loading:false,
                success: action.payload,
            };
            break;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/downloadHotspotReducer.js